import { FC, useState } from 'react';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import styles from './DiscoverSearchPanel.module.scss';
import { FilterIcon } from '../../../../../components/Icons';

type DiscoverSearchPanelProps = {
  isMobile: boolean;
  sectionTitle: string;
  cardTitle: string;
  children: React.ReactNode;
  onFilterClick?: () => void;
};

const DiscoverSearchPanel: FC<DiscoverSearchPanelProps> = ({
  isMobile,
  sectionTitle,
  cardTitle,
  children,
  onFilterClick,
}) => {
  const [expanded, setExpanded] = useState(true);

  if (!isMobile) {
    return <>{children}</>;
  }

  return (
    <Box className={styles.mobileSearchPanel}>
      <Box className={styles.sectionHeader}>
        <Typography variant="h9Bold" sx={{ color: '#222B3A' }}>
          {sectionTitle}
        </Typography>
        {onFilterClick ? (
          <IconButton
            type="button"
            size="small"
            className={styles.filterButton}
            aria-label="Filters"
            onClick={() => {
              onFilterClick();
            }}
          >
            <FilterIcon className={styles.panelIcon} />
          </IconButton>
        ) : null}
      </Box>

      <Box className={styles.card}>
        <button
          type="button"
          className={styles.cardHeader}
          onClick={() => setExpanded(v => !v)}
          aria-expanded={expanded}
        >
          <Typography variant="h10Bold" sx={{ color: '#222B3A' }}>
            {cardTitle}
          </Typography>
          {expanded ? (
            <ExpandLess className={`${styles.cardChevron} ${styles.panelIcon}`} aria-hidden />
          ) : (
            <ExpandMore className={`${styles.cardChevron} ${styles.panelIcon}`} aria-hidden />
          )}
        </button>

        <Collapse in={expanded}>
          <Box className={styles.cardBody}>{children}</Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default DiscoverSearchPanel;
